import DetailProfile from '../screens/user/DetailProfile'
import { ResetPasswordForm } from '../screens/login/ResetPasswordForm'
import React from 'react'
import { BrowserRouter, createBrowserRouter, createRoutesFromElements, Route, RouterProvider, Routes, Navigate } from 'react-router-dom'
import InternalLayout from '../components/layouts/InternalLayout'
import { Login } from '../screens/login/Login'
import PrivateRoute from "./PrivateRoute"
import UsersList from '../screens/user/ListUsers'
import ListUsersAdministrator from '../screens/user_administrator/ListUsersAdministrator'
import DetailUserAdministrator from '../screens/user_administrator/DetailUserAdministrator'
import ListClients from '../screens/client/ListClients'
import DetailClient from '../screens/client/DetailClient'
import DetailUser from '../screens/user/DetailUser'
import ListNotifications from '../screens/notification/ListNotifications'
import ListScheduledNotifications from '../screens/scheduledNotification/ListScheduledNotifications'
import { ListContent } from '../screens/campaign/components/day/ListContent'
import { Breadcrumb } from '../components/breadcrumb/Breadcrumb'
import { displayMessage } from '../helpers/messages'
import { LoginForm } from '../screens/login/LoginForm'
import ChangePassword from '../screens/login/ChangePassword'
import TermsOfUse from '../screens/login/TermsOfUse'
// Treinos
import { ListGymWorkouts } from '../screens/training/gym/ListGymWorkouts'
import { ListHomeWorkouts } from '../screens/training/home/ListHomeWorkouts'
import { ListStretchings } from '../screens/training/stretching/ListStretchings'
// Catálogo de exercícios
import { ListExercises } from '../screens/training/exercises/ListExercises'
// Dietas
import { ListDiets } from '../screens/diet/ListDiets'
// Analytics
import AnalyticsScreen from '../screens/analytics/AnalyticsScreen'

const router = (
  <>
    <Route path='/' element={<PrivateRoute />}  >
      <Route element={<InternalLayout />}>
        <Route path='users' >
          <Route
            index
            element={
              <Breadcrumb
                listCrumbs={[{ label: displayMessage('USERS'), link: '/users' }]}>
                <UsersList />
              </Breadcrumb>
            }
          />

          <Route
            path=':idUser'
            element={
              <Breadcrumb
                listCrumbs={[
                  { label: displayMessage('USERS'), link: '/users' },
                  { label: displayMessage('USER') + ': {idUser}', params: ['idUser'] }
                ]}>
                <DetailUser />
              </Breadcrumb>
            }
          />
        </Route>

        <Route path='administrators' >
          <Route
            index
            element={
              <Breadcrumb
                listCrumbs={[{ label: displayMessage('USERS'), link: '/administrators' }]}>
                <ListUsersAdministrator />
              </Breadcrumb>
            }
          />

          <Route
            path=':idUser'
            element={
              <Breadcrumb
                listCrumbs={[
                  { label: displayMessage('USERS'), link: '/administrators' },
                  { label: displayMessage('USER') + ': {idUser}', params: ['idUser'] }
                ]}>
                <DetailUserAdministrator />
              </Breadcrumb>
            }
          />
        </Route>

        <Route path="clients">
          <Route
            index
            element={
              <Breadcrumb
                listCrumbs={[{ label: displayMessage('CLIENTS') }]}
              >
                <ListClients />
              </Breadcrumb>
            }
          />

          <Route path=':idClient'>
            <Route
              index
              element={
                <Breadcrumb
                  listCrumbs={[
                    { label: displayMessage('CLIENTS'), link: '/clients' },
                    { label: displayMessage('CLIENT') + ': {idClient}', params: ['idClient'] },
                  ]}
                >
                  <DetailClient />
                </Breadcrumb>
              }
            />

            <Route
              path='users/:idUser'
              element={
                <Breadcrumb
                  listCrumbs={[
                    { label: displayMessage('CLIENTS'), link: '/clients' },
                    { label: displayMessage('CLIENT') + ': {idClient}', link: '/clients/{idClient}', params: ['idClient'] },
                    { label: displayMessage('USER') + ': {idUser}', params: ['idUser'] },
                  ]}
                >
                  <DetailUser />
                </Breadcrumb>
              }
            />
          </Route>
        </Route>

        <Route
          path="profile"
          element={
            <Breadcrumb
              listCrumbs={[{ label: displayMessage('MY_PROFILE') }]}
            >
              <DetailProfile />
            </Breadcrumb>
          }
        />

        <Route
          path='notifications'
          element={
            <Breadcrumb
              listCrumbs={[{ label: displayMessage('NOTIFICATIONS') }]}
            >
              <ListNotifications />
            </Breadcrumb>
          }
        />

        <Route
          path='scheduled-notifications'
          element={
            <Breadcrumb
              listCrumbs={[{ label: 'Notificações Agendadas' }]}
            >
              <ListScheduledNotifications />
            </Breadcrumb>
          }
        />

        <Route
          path='contents'
          element={
            <Breadcrumb
              listCrumbs={[
                { label: displayMessage('CONTENTS') }
              ]}
            >
              <ListContent />
            </Breadcrumb>
          }
        />

        <Route
          path='exercises'
          element={
            <Breadcrumb
              listCrumbs={[
                { label: displayMessage('EXERCISE_CATALOG') }
              ]}
            >
              <ListExercises />
            </Breadcrumb>
          }
        />

        <Route
          path='gym-workouts'
          element={
            <Breadcrumb
              listCrumbs={[
                { label: displayMessage('GYM_WORKOUTS') }
              ]}
            >
              <ListGymWorkouts />
            </Breadcrumb>
          }
        />

        <Route
          path='home-workouts'
          element={
            <Breadcrumb
              listCrumbs={[
                { label: displayMessage('HOME_WORKOUTS') }
              ]}
            >
              <ListHomeWorkouts />
            </Breadcrumb>
          }
        />

        <Route
          path='stretchings'
          element={
            <Breadcrumb
              listCrumbs={[
                { label: displayMessage('STRETCHINGS') }
              ]}
            >
              <ListStretchings />
            </Breadcrumb>
          }
        />

        <Route
          path='diets'
          element={
            <Breadcrumb
              listCrumbs={[
                { label: displayMessage('DIET_MANAGEMENT') }
              ]}
            >
              <ListDiets />
            </Breadcrumb>
          }
        />

        <Route
          path='analytics'
          element={
            <Breadcrumb
              listCrumbs={[{ label: 'Indicadores de Engajamento' }]}
            >
              <AnalyticsScreen />
            </Breadcrumb>
          }
        />

        <Route
          index
          element={<Navigate to="/users" replace />}
        />
      </Route>

      <Route path="change-password" element={<ChangePassword />} />
    </Route>

    <Route path="login" element={<Login />} >
      <Route index element={<LoginForm />} />
      <Route path="reset-password/:token" element={<ResetPasswordForm />} />
    </Route>

    <Route path="termos" element={<TermsOfUse />} >
    </Route>
    {/* <Route path="/reset-password" element={<ResetPassword />} /> */}
  </>
)

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {router}
      </Routes>
    </BrowserRouter>
  )
}

export default Router;
